import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import apiService from '../src/services/api.service'
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment'
export const bus = new Vue();
export const api_service = new apiService();
Vue.prototype.moment = moment

Vue.use(VueSweetalert2);

Vue.config.productionTip = false
Vue.prototype.$apiService = new apiService();


// Vue.filter('truncate', function (text, length, suffix) {
//   if (text.length > length) {
//     return text.substring(0, length) + suffix
//   } else {
//     return text
//   }
// })

new Vue({
  router,
  store,
  VueSweetalert2,
  vuetify,
  render: h => h(App)
}).$mount('#app')
